import React, { Component } from "react";
import AdminTablesComponent from './components/AdminTablesComponent';

import PropTypes from 'prop-types';

export class AdminTablesContainer extends Component {
    constructor (props){
        super(props)
        this.state = {

        }

    }

    render(){
        return(
            <AdminTablesComponent />
        )
    }
          
        
}

AdminTablesContainer.defaultProps={

}
AdminTablesContainer.propTypes = {

}

export default(AdminTablesContainer);